import { AnimatePresence, motion } from 'framer-motion';
import Backdrop from '../Backdrop';
import Button from '../Button';
import { ChevronLeft } from 'react-feather';
import classNames from 'classnames';
var slideLeft = {
    hidden: {
        x: '100%',
        opacity: 0,
    },
    visible: {
        x: '0',
        opacity: 1,
        transition: {
            duration: 0.25,
        },
    },
    exit: {
        x: '100%',
        opacity: 0,
    },
};
var Drawer = function (_a) {
    var handleClose = _a.handleClose, handleBack = _a.handleBack, children = _a.children, open = _a.open, _b = _a.withBack, withBack = _b === void 0 ? true : _b, className = _a.className, _c = _a.containsDraggable, containsDraggable = _c === void 0 ? false : _c;
    return (<AnimatePresence initial={false} exitBeforeEnter={true} onExitComplete={function () { return null; }}>
      {open && (<Backdrop onClick={handleClose}>
          <motion.div onClick={function (e) { return e.stopPropagation(); }} className={classNames(className, 'absolute top-0 right-0 flex h-full w-full flex-col', !containsDraggable
                ? 'bg-white w-full sm:w-10/12 md:w-4/5 lg:w-4/6 xl:w-1/2 2xl:w-2/5'
                : 'pointer-events-none')} variants={slideLeft} initial="hidden" animate="visible" exit="exit">
            {withBack && (<div className={classNames('p-4 pt-6 sm:p-6 md:pt-10', containsDraggable &&
                    'bg-white ml-auto pointer-events-auto w-full sm:w-10/12 md:w-4/5 lg:w-4/6 xl:w-1/2 2xl:w-2/5')}>
                <Button icon={ChevronLeft} type="inline" side="start" onClick={handleBack !== null && handleBack !== void 0 ? handleBack : handleClose}>
                  Précédent
                </Button>
              </div>)}
            <div className={classNames('flex-1 overflow-y-auto', containsDraggable &&
                'bg-white ml-auto pointer-events-auto w-full sm:w-10/12 md:w-4/5 lg:w-4/6 xl:w-1/2 2xl:w-2/5')}>
              {children}
            </div>
          </motion.div>
        </Backdrop>)}
    </AnimatePresence>);
};
export default Drawer;
